<template>
  <div>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form
        class="needs-validation"
        @submit.prevent="handleSubmit(firstFormSubmit)"
      >
        <div class="form-row">
          <b-col md="12">
            <base-input rules="required" label="Mensagem">
              <textarea
                class="form-control"
                v-model="form.message"
                id="issuesComentary"
                name="Mensagem"
                rows="3"
              ></textarea>
            </base-input>
          </b-col>
        </div>
        <div class="text-right">
          <base-button
            :disabled="formDisableButton"
            type="primary"
            native-type="submit"
            >{{ formButtonText }}</base-button
          >
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
export default {
  props: {
    formButtonText: {
      type: String,
      default: "Enviar",
    },
    formDisableButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        message: "",
        title: "Mengagem", // titulo default
      },
      validated: false,
      showAlert: false,
    };
  },
  methods: {
    async firstFormSubmit() {
      this.$emit("submit", this.form);
    },
    resetFormMessage() {
      console.log("cleannig...");
      this.form.message = "";
      this.$refs.formValidator.reset();
    },
  },
};
</script>

<style>
</style>